import { IssueCaseDoc, IssueCaseStatusCode, IssueSourceType } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';

import { observeIssueCases } from 'src/utils/firebase/firebase-short-cut';

const useIssueCasesForCase = (issueCaseId: string | undefined) => {
  const [issueCases, setIssueCases] = useState<IssueCaseDoc[]>([]);

  useEffect(() => {
    if (issueCaseId) {
      const subscription = observeIssueCases([
        ['sourceId', '==', issueCaseId],
        ['sourceType', '==', IssueSourceType.ISSUE],
        ['status', 'not-in', [IssueCaseStatusCode.DELETED, IssueCaseStatusCode.CANCELED]],
      ]).subscribe((docs) => {
        setIssueCases(docs.sort((a, b) => a._timeCreate.toDate().getTime() - b._timeCreate.toDate().getTime()));
      });
      return () => subscription.unsubscribe();
    } else {
      setIssueCases([]);
    }
  }, [issueCaseId]);

  return issueCases;
};

export default useIssueCasesForCase;
